module.exports = __webpack_public_path__ + "img/grey.28ab4aa7.png";